import { NumberInput, TextField, TextInput } from "react-admin";
import { JsonField } from "../ra-lb-tools/components/jsonField";
import { MyList } from "../ra-lb-tools/components/myList";
import { LockerField, LockerInput } from "../components/referenceFields";
import { TowerField, TowerInput } from "./tower/towers";
import { MyDateField } from "../ra-lb-tools/components/myDateField";
import { PacketTypeField, PacketTypeInput } from "./enums/packet_types";

export default function CommandsList(props) {
  const filters = [
    <NumberInput source="id" alwaysOn key={1} />,
    <LockerInput source="lockerId" alwaysOn key={2} />,
    <TowerInput source="towerId" alwaysOn key={3} />,
    <PacketTypeInput source="packetType" alwaysOn key={4} />,
    <TextInput
      label="Client info"
      source="commandData.client_info"
      alwaysOn
      key={5}
    />,
  ];

  const resource = "commands";

  return (
    <MyList
      {...props}
      resource={resource}
      filters={filters}
      queryOptions={{
        meta: {
          transformResponse: (response) => ({
            ...response,
            _id: response.id,
            id: `${response.id}-${response.towerId}`,
          }),
        },
      }}
      sort={{
        field: "created",
        order: "DESC",
      }}
    >
      <TextField source="_id" label="Id" />
      <PacketTypeField
        source="commandData.packet_type"
        label="Packet type"
        sortable={false}
      />
      <JsonField source="commandData" />
      <MyDateField source="created" showTime={true} />
      <TextField source="description" />
      <LockerField source="commandData.locker_id" label="Locker" />
      <TowerField source="towerId" />
    </MyList>
  );
}
